/* eslint-disable no-unused-vars */
<template>
  <b-overlay
    :show="loader.screen"
    rounded="sm"
  >

    <div>
      <!-- Table Container Card -->
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >

        <UsersListFilters
          :planes="PlanEstudios"
          :loader="loader.filters"
        />
        <!-- Datos cargados -->
        <b-card-header class="pb-0">
          <b-card-title />
          <b-card-text class="font-small-2 mr-25 mb-0">
            Datos cargados <b>{{ updatedAt }}</b>
          </b-card-text>
        </b-card-header>
        <!-- Table Top -->
        <div class="m-2">
          <b-row>
            <!-- Cantidad de elementos por página -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span>Mostrar</span>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
            </b-col>
            <!-- Buscador -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon
                      :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                      :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                      @click="searchQuery != '' ? searchQuery = '' : ''"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="searchQuery"
                    placeholder="Buscar por nombre del alumno"
                  />
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-overlay
          rounded="sm"
          :show="isBusyTable"
          opacity="0"
        >
          <b-table
            ref="refDataListTable"
            class="position-relative"
            empty-text="No se encontraron resultados"
            primary-key="table_usuarios_moodle"
            responsive
            show-empty
            hover
            striped
            :tbody-tr-class="rowClass"
            :items="fetchData"
            :fields="tableColumns"
            :sort-desc.sync="isSortDirDesc"
            :sort-by.sync="sortBy"
            @row-clicked="clickenrow"
          >
            <template #cell(id)="data">
              <p>{{ data.item.id }}</p>
              <p>{{ data.item.fullname }}</p>
              <p>{{ data.item.email }}</p>
            </template>
            <template #cell(fullname)="data">
              <div v-if="data.item.detalle[0] !== undefined">
                <p>{{ data.item.detalle[0].moodle_id }}</p>
                <p>{{ data.item.detalle[0].nombreCompleto }} </p>
                <p>{{ data.item.detalle[0].emal_principal }}</p>
              </div>
            </template>
            <template #cell(email)="data">
              <div v-if="data.item.detalle[0] !== undefined">
                <p>{{ data.item.detalle[0].matricula }}</p>
              </div>
            </template>
            <template #row-details="row">
              <hr>
              <div class="mx-5">
                <b-row>
                  <b-col
                    cols="4"
                  >
                    <div v-if=" row.item.kardex.length > 0">
                      <b-list-group>
                        <span>Cursando</span><br>
                        <b-list-group-item
                          v-for="(kardex, index) in row.item.kardex.filter(word => word.status === 'C1' || word.status === 'C2' || word.status === 'C3')"
                          :key="'cursando' + index"
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="my-0">
                            <small><b> Nivel {{ kardex.orden }} : </b></small>
                            <small class="text-primary"><b>{{ kardex.nombre_materia }} : </b></small>
                            <small><b> Periodo {{ kardex.periodo_agenda }} : </b></small>
                            <small>  {{ kardex.descripcion }}</small>
                          </p>

                          <b-badge
                            variant="primary"
                            pill
                            class="badge-round"
                          >
                            {{ kardex.status }}
                          </b-badge>
                        </b-list-group-item>

                      </b-list-group></div>
                  </b-col>
                  <b-col
                    cols="4"
                  >
                    <div v-if=" row.item.kardex.length > 0">
                      <b-list-group>
                        <span>Aprobadas</span><br>
                        <b-list-group-item
                          v-for="(kardex2, index2) in row.item.kardex.filter(word => word.status === 'AP' || word.status === 'AE' || word.status === 'AR' || word.status === 'AX')"
                          :key="'aprobadas' + index2"
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="my-0">
                            <small><b> Nivel {{ kardex2.orden }} : </b></small>
                            <small class="text-primary"><b>{{ kardex2.nombre_materia }} : </b></small>
                            <small><b> Periodo {{ kardex2.periodo_agenda }} : </b></small>
                            <small><b> Calificación {{ kardex2.cal_fin }} : </b></small>
                            <small>  {{ kardex2.descripcion }}</small>
                          </p>

                          <b-badge
                            variant="primary"
                            pill
                            class="badge-round"
                          >
                            {{ kardex2.status }}
                          </b-badge>
                        </b-list-group-item>

                      </b-list-group></div>
                  </b-col>
                  <b-col
                    cols="4"
                  >
                    <div v-if=" row.item.kardex.length > 0">
                      <b-list-group>
                        <span>Otros estados</span><br>
                        <b-list-group-item
                          v-for="(kardex3, index3) in row.item.kardex.filter(word => word.status === 'BD' || word.status === 'BT' || word.status === 'EX' || word.status === 'NA')"
                          :key="'otros' + index3"
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="my-0">
                            <small><b> Nivel {{ kardex3.orden }} : </b></small>
                            <small class="text-primary"><b>{{ kardex3.nombre_materia }} : </b></small>
                            <small><b> Periodo {{ kardex3.periodo_agenda }} : </b></small>
                            <small><b> Calificación {{ kardex3.cal_fin }} : </b></small>
                            <small>  {{ kardex3.descripcion }}</small>
                          </p>

                          <b-badge
                            variant="primary"
                            pill
                            class="badge-round"
                          >
                            {{ kardex3.status }}
                          </b-badge>
                        </b-list-group-item>

                      </b-list-group></div>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-table>
        </b-overlay>
        <!-- Table's footer & pagination -->
        <div class="mx-2 mb-2">
          <b-row>
            <!-- Leyenda de cuantos elementos se muestran -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BCardHeader,
  BCardText,
  BCardTitle,
  BInputGroup,
  BInputGroupPrepend,
  BOverlay,
  BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onMounted, watch } from '@vue/composition-api'
import {
  lastUpdate,
  timestampToDate,
  nombreModalidad,
  avatarText,
} from '@core/utils/filter'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import { configTableUsuarios, useUsuariosMoodleCatalogos } from '@/views/campus/adminMoodle/UsuariosMoodle/useUsuariosMoodle'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UsersListFilters from './components/PeriodoNivelEspecialidad.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    vSelect,
    BOverlay,
    UsersListFilters,
    BBadge,
    BListGroup,
    BListGroupItem,

  },
  data() {
    return {
      loader: {
        screen: false,
      },
    }
  },
  setup() {
    const updatedAt = ref(lastUpdate())
    const errorContent = ref({ filters: false, table: false })
    const { tableColumns, configRequest } = configTableUsuarios()
    const { PlanEstudios, PlanEstudiosOptionsPromise } = useUsuariosMoodleCatalogos()
    const toast = useToast()
    const loader = ref({ filters: false })
    const {
      fetchData, refetchData, refDataListTable,
      dataMeta,
      dynamicParamRequest,
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc, dataAux,
      isBusyTable,
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const fetchCatalogosFilters = () => {
      loader.value.filters = true
      Promise.all([PlanEstudiosOptionsPromise])
        .then(() => { loader.value.filters = false })
        .catch(error => {
          loader.value.filters = false
          errorContent.value.filters = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Catalogos de filtros]',
              text: `${error} Descuida, puedes seguir trabajando con la tabla de resultados, nosotros verémos la manera de solucionar el inconveniente ;)`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    //* On mounted
    onMounted(() => {
      fetchCatalogosFilters() //* Load filter options (selects)
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })
    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data

    return {
      fetchData,
      dataAux,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      // Filter
      lastUpdate,
      updatedAt,
      timestampToDate,
      nombreModalidad,
      avatarText,
      // Extra Filters
      configRequest,
      isBusyTable,
      // Error
      errorContent,
      // Filter's option
      PlanEstudios,
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickenrow(item, index) {
      // eslint-disable-next-line no-underscore-dangle
      this.$set(item, '_showDetails', !item._showDetails)
    },

    rowClass(item, type) {
      let classColor = ''
      if (!item || type !== 'row') { return }
      if (item.detalle[0] !== undefined) {
        if (item.fullname !== item.detalle[0].nombreCompleto) { classColor = 'table-warning' }
        if (item.email !== item.detalle[0].emal_principal) { classColor = 'table-info' }
        if (item.id !== item.detalle[0].moodle_id) { classColor = 'table-danger' }
        // eslint-disable-next-line consistent-return
        return classColor
      } classColor = 'table-danger'
      // eslint-disable-next-line consistent-return
      return classColor
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
